import { connect } from 'react-redux';

import { actionCleanupDiscoveryCategories, actionGetDiscoveryCategories } from 'store/actions';
import { actionCleanupDiscoveryProvinces, actionGetDiscoveryProvinces } from 'store/discover-province/actions';
import { actionCleanupDiscoverReviews, actionDeleteDiscoveryReview, actionGetDiscoveryReviews } from 'store/discover-review/actions';
import ManagerDiscoveryReview from './ManagerDiscoveryReview';

const mapStateToProps = (state) => ({
  reviews: state.DiscoverReview.reviews,
  reviewsLoading: state.DiscoverReview.reviewsLoading,

  provincesLoading: state.DiscoverProvince.provincesLoading,
  provinces: state.DiscoverProvince.provinces,

  categoriesLoading: state.DiscoverCategory.categoriesLoading,
  categories: state.DiscoverCategory.categories,

  isDeleteDiscoveryReviewLoading: state.DiscoverReview.deleteDiscoveryReviewLoading,
});

const mapDispatchToProps = (dispatch) => ({
  // Discover Review
  actionGetDiscoveryReviews: (payload) =>
    dispatch(actionGetDiscoveryReviews(payload)),
  actionCleanupDiscoverReviews: () =>
    dispatch(actionCleanupDiscoverReviews()),
  actionDeleteDiscoveryReview: (payload) =>
    dispatch(actionDeleteDiscoveryReview(payload)),

  // Discover Province
  actionGetDiscoveryProvinces: (payload) =>
    dispatch(actionGetDiscoveryProvinces(payload)),
  actionCleanupDiscoveryProvinces: (payload) =>
    dispatch(actionCleanupDiscoveryProvinces(payload)),

  // Discover Category
  actionGetDiscoveryCategories: (payload) =>
    dispatch(actionGetDiscoveryCategories(payload)),
  actionCleanupDiscoveryCategories: () =>
    dispatch(actionCleanupDiscoveryCategories()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagerDiscoveryReview);
